import * as PusherTypes from 'pusher-js';
import Pusher from 'pusher-js';

type PusherOptions = {
	appKey: string;
	options: PusherTypes.Options;
};

type Subscriptions = {
	channel: PusherTypes.Channel;
	events: string[];
};

const usePusher = (pusherOptions: PusherOptions) => {
	const pusher = new Pusher(pusherOptions.appKey, pusherOptions.options);
	let subscriptions: Record<string, Subscriptions> = {};
	const subscribeToChannel = <T>(channelName: string, eventName: string, callback: (data: T) => void) => {
		let subscription = subscriptions[channelName];

		if (!subscription) {
			subscription = subscriptions[channelName] = {
				channel: pusher.subscribe(channelName),
				events: [],
			};
		}

		subscription.channel.bind(eventName, (data: T) => {
			callback(data);
		});

		subscription.events.push(eventName);
	};

	const unsubscribeFromChannel = (channelName: string, eventName: string) => {
		const subscription = subscriptions[channelName];

		if (subscription && subscription.events.includes(eventName)) {
			subscription.channel.unbind(eventName);
			subscription.events = subscription.events.filter((event: string) => event !== eventName);

			if (subscription.events.length === 0) {
				pusher.unsubscribe(channelName);
				delete subscriptions[channelName];
			}
		}
	};

	const disconnect = () => {
		pusher.disconnect();
		subscriptions = {};
	};

	return {
		subscribeToChannel,
		unsubscribeFromChannel,
		disconnect,
	};
};

export { usePusher, PusherOptions };
